type SpinnerProps = {
  size?: "sm" | "lg";
  className?: string;
};

const sizeClass = {
  sm: "h-8 w-8",
  lg: "h-12 w-12",
};

export default function Spinner({ size = "sm", className = "" }: SpinnerProps) {
  return (
    <div
      className={`animate-spin rounded-full border-4 border-primary-500 border-t-transparent ${sizeClass[size]} ${className}`}
    />
  );
}
